import { SelectableOption } from "../../Shared/Shared"
import { SelectableOptionView } from "./Dropdown.Item"

interface Props {
  options?: SelectableOption[]
  value?: any
  openHeight: number
  showSearch: boolean
  searchQuery: string
  setSearchQuery?(searchQuery: string): void
  itemSelected?(item: SelectableOption): void
}

export function DropdownContent(props: Props) {
  const { options, openHeight, showSearch, searchQuery, setSearchQuery, itemSelected, value } = props;
  const style = { height: openHeight + "px" }

  return <div className="DropwdownContent" style={style}>
    <div className="DropdownContentInner">
      {showSearch && <div className="dropdownSearch">
        <input
          placeholder="Search..."
          onChange={(e) => setSearchQuery && setSearchQuery(e.target.value)}
          value={searchQuery}
        />
        <i className="fa fa-search" />
      </div>
      }

      {options && options.map((option, index) => {
        return <SelectableOptionView key={index} item={option} itemSelected={itemSelected} value={value} />
      })}
    </div>
  </div>
}
